import React from 'react';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { Box, Divider } from '@mui/material';
import type { HistoryRecords } from './types';
import { Dialog } from '../../../../../components';

export type HistoryRecordDialogProps = {
  dialogTitle: string;
  historyRecords: HistoryRecords[];
  openDialog: boolean;
  cancelAction?: string;
  onDialogClose: () => void;
};

export const HistoryRecordDialog: React.FC<HistoryRecordDialogProps> = (
  props: HistoryRecordDialogProps,
) => {
  const {
    dialogTitle,
    historyRecords = [],
    openDialog,
    cancelAction,
    onDialogClose,
  } = props;
  return (
    <Dialog
      dialogTitle={dialogTitle}
      openDialog={openDialog}
      onDialogClose={onDialogClose}
      displayCloseButton
      cancelAction={cancelAction}
      width={'38rem'}
    >
      <div className="flex flex-col items-center h-[28rem] overflow-auto ">
        {historyRecords.map((historyRecord, index) => {
          const historyYear = dayjs(historyRecord.date).year();
          const historyMonth = dayjs(historyRecord.date).format('MMM'); // Get full month name
          const historyDay = dayjs(historyRecord.date).date();
          return (
            <div key={index} className="flex flex-row">
              <div className="flex flex-col items-center mb-3">
                <DateTitle>
                  <h2>{historyDay}</h2>
                  <h3>{historyMonth + ', ' + historyYear}</h3>
                </DateTitle>
                <Divider orientation="vertical" />
              </div>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '0.3rem 1rem',
                  backgroundColor: '#FAFAFA',
                  borderRadius: '5px',
                  margin: '0.5rem',
                }}
              >
                {historyRecord.content.map((record, index) => {
                  return (
                    <Box
                      sx={{
                        border: '1px solid #E0E0E0',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '5px',
                        padding: '0.5rem',
                        margin: '0.5rem 0',
                        minHeight: '5rem',
                        width: '25rem',
                        wrap: 'wrap',
                        fontSize: '0.9rem',
                      }}
                      key={index}
                    >
                      <div className="font-medium">
                        {`${record.createdAt} by ${record.createdBy}(${record.userRole})`}
                      </div>
                      <div>{record.snapshot}</div>
                    </Box>
                  );
                })}
              </Box>
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};

const DateTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background-color: #ffffff;

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
  }

  h3 {
    font-size: 0.9rem;
    font-weight: 700;
    margin: 0;
  }
`;
